<template>

<main>
    <div class="loginError">{{ loginError }}</div>
    <div v-if="admin" class="login">
      <p>Admin Password:</p>
      <input v-model="password" type="password">
      <button @click="login">Login</button>
      <small @click="admin=false">Switch to User Login</small>

      <div class="instance">
        <div class="loginError">{{ instanceError }}</div>
        <div v-if="instance.length === 0 || instance === 'default' && instanceError === null">
          Connected to default instance
        </div>
        <input v-model="instance"> <button @click="setInstance">Connect</button>
      </div>

    </div>

    <div v-else>
      <div v-if="userLogin" class="login">
        <p>Enter the email you recieve entries at:</p>
        <input v-model="email" type="email">
        <button @click="loginUser">Login</button>
      </div>
      <div v-else>Client login is not currently enabled.</div>
      <small>&nbsp;</small>

      <div class="instance">
        <div class="loginError">{{ instanceError }}</div>
      </div>
    </div>

</main>
</template>

<script>
/* eslint-disable import/no-cycle */
import Api from '@/services/Api';
import AuthService from '@/services/Auth';

export default {
  name: 'Login',
  data() {
    return {
      admin: false,
      email: '',
      password: '',
      loginError: null,
      userLogin: false,
      instance: '',
      instanceError: null,
    };
  },
  methods: {
    async login() {
      try {
        const response = await AuthService.login({ password: this.password });
        this.$store.dispatch('setToken', response.data.token);
        this.$router.push({ name: 'Dashboard' });
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
        if (err.response) this.loginError = err.response.data.error;
        else this.loginError = `${err}`;
      }
    },
    async loginUser() {
      try {
        const response = await AuthService.loginUser({ email: this.email });
        this.loginError = response.data;
        // this.$store.dispatch('setUser', response.data.user);
        this.$router.push({ name: 'Dashboard' });
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
        if (err.response) this.loginError = err.response.data.error;
        else this.loginError = 'Login Error';
      }
    },
    async setInstance() {
      this.$store.dispatch('setInstance', this.instance);
      Api().get('settings').then(async (res) => {
        this.instanceError = null;
        this.userLogin = res.data.userLogin;
      }).catch(() => {
        this.instanceError = 'Unable to connect to instance';
      });
    },
  },
  async created() {
    this.instance = this.$store.getters.instance;
    if (this.$route.query.instance) {
      this.instance = this.$route.query.instance;
      this.$store.dispatch('setInstance', this.instance);
    }
    document.onkeydown = (event) => {
      if (event.key === 'Escape' || event.key === 'Esc') { this.admin = !this.admin; }
      if (event.key === 'Enter') { if (this.admin) this.login(); else this.loginUser(); }
    };
    Api().get('settings').then(async (res) => {
      this.instanceError = null;
      this.userLogin = res.data.userLogin;

      if (this.userLogin && this.$route.query.token && this.$route.query.uid) {
        const response = await AuthService.pwl({
          token: this.$route.query.token, uid: this.$route.query.uid,
        });
        this.$store.dispatch('setToken', response.data.token);
        if (response.data.user) this.$store.dispatch('setUser', response.data.user);
        this.$router.push({ name: 'Dashboard' });
      }
    }).catch(() => {
      this.instanceError = 'Unable to connect to instance';
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

main {
  background: var(--black);
  color: var(--white);
  font-family: 'Roboto', sans-serif;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loginError {
  color: var(--red);
}

.login {
  min-width: 275px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login p { text-align: center; }

.login input {
  padding: 1em;
  border: 0;
  border-left: 5px solid transparent;
}
.login input:focus {
  border-left: 5px solid var(--blue)
}

.login button {
  display: inline-block;
  margin-top: 5%;
  text-transform: uppercase;
  font-size: 1.2em;
  color: var(--white);
  background: transparent;
  border: 1px solid var(--white);
  padding: 10px;
  transition: 0.25s ease-in-out;
  cursor: pointer;
}
.login a:hover, .login button:hover {
  background: var(--white);
  color: var(--black);
}

small {
  display: block;
  margin-top: 60px;
  text-align: center;
  cursor: pointer;
}

.instance {
  position: fixed;
  margin-left: 30px;
  bottom: 20px;
}

.instance input {
  width: 100px;
  padding: 11px;
  font-size: 1.2em;
}

</style>
